import {Component, Input, Output, EventEmitter, Pipe, PipeTransform, HostListener, ViewChild, ViewChildren} from '@angular/core';

import {UserService} from '../shared/user.service';

@Pipe({
    name: 'memberSearch',
    pure: false
})
export class MemberSearchTeam implements PipeTransform {
    transform(options, search) {
        if( !search ) {
            return options;
        }
        search = search.toLowerCase();
        return options.filter(member => {
            let text = member.abbreviation + ' ' + member.name;
            text = text.toLowerCase();
            return text.indexOf(search) !== -1;
        });
    }
}
@Pipe({
    name: 'notInTeam',
    pure: false
})
export class NotInTeam implements PipeTransform {
    transform(options, team) {
        if( !team ) {
            return options;
        }
        const ids = team.map(item => item.id);
        return options.filter(item => ids.indexOf(item.id) === -1);
    }
}
@Component({
    selector: 'team-component',
    templateUrl: 'team.component.html'
})
export class TeamComponent {
    memberSearchText = '';
    options = [];
    panelOpen = false;
    roles = ['writer', 'pageAddWriter', 'editor', 'dmc'];
    roleMap = {
        writer: 'Writer',
        pageAddWriter: 'Page Additions Writer',
        editor: 'Editor',
        dmc: 'DMC',
        follower: 'Follower'
    };
    roleIndexOpen = -1;

    private _canEdit = false;
    private _listOnly = false;
    private _team = [];

    @Input('team')
    set team(team) {
        this._team = team;
    }
    get team() {
        return this._team;
    }
    @Input('canEdit') 
    set canEdit(canEdit) {
        this._canEdit = canEdit;
    }
    get canEdit() {
        return this._canEdit;
    }
    @Input('listOnly') 
    set listOnly(listOnly) {
        this._listOnly = listOnly;
    }
    get listOnly() {
        return this._listOnly;
    }

    @Output() teamChanged = new EventEmitter();

    @HostListener('document:click', ['$event'])
    @HostListener('document:keydown.escape')
    closePanel(event) {
        if( !event ) {
            this.panelOpen = false;
            this.roleIndexOpen = -1;
            return;
        }
        if( this.roleIndexOpen !== -1 ) {
            this.roleDropdowns.forEach(item => {
                if( item.nativeElement.dataset.index == this.roleIndexOpen && !item.nativeElement.contains(event.target) ) {
                    this.roleIndexOpen = -1;
                }
            });
        }
        if( this.panelOpen && !this.teamDropdown.nativeElement.contains(event.target) ) {
            this.panelOpen = false;
        }
    }

    @ViewChildren('roleDropdown') roleDropdowns;
    @ViewChild('teamDropdown') teamDropdown;

    constructor(private userService: UserService) {}
    ngAfterViewInit() {
        this.options = this.userService.getUsers();
    }
    getTitleText(member) {
        if( !Array.isArray(member.filteredRoles) ) {
            return '';
        }
        return member.filteredRoles.map(role => this.roleMap[role]).join(', ');
    }
    isMember(member) {
        return this.team.filter(item => item.id == member.id).length > 0;
    }
    addMember(option) {
        const member = JSON.parse(JSON.stringify(option));
        this.maybeAddRole(member.role, member);
        if( this.isMember(member) ) {
            return;
        }
        this.team.push(member);
        this.teamChanged.emit({
            action: 'memberAdded',
            data: { 
                member: member
            }
        });
        this.memberSearchText = '';
        this.panelOpen = false;
    }
    removeMember(member) {
        let i = this.team.length;
        while(i--) {
            if(this.team[i].id == member.id) {
                this.team.splice(i, 1).concat([]); // <-- concat for triggering angular change detection
                this.teamChanged.emit({
                    action: 'memberRemoved',
                    data: { 
                        member: member
                    }
                });
                if( member.roles.indexOf('writer') !== -1 ) {
                    this.teamChanged.emit({
                        action: 'roleRemoved',
                        data: {
                            role: 'writer', 
                            member: member
                        }
                    });
                }
                break;
            }
        }
    }
    getMemberRoles(member) {
        const roles = this.roles;
        return member.roles.filter(item => roles.indexOf(item) !== -1);
    }
    getSelectedRoleText(member) {
        const roleMap = this.roleMap;
        const memberRoles = this.getMemberRoles(member);
        let text = [];
        for(var i = 0; i < memberRoles.length; i++) {
            const role = memberRoles[i];
            text.push(roleMap[role]);
        }
        return text.join(', ') || 'Follower';
    }
    isChecked(role, member) {
        const memberRoles = this.getMemberRoles(member);
        return memberRoles.indexOf(role) !== -1;
    }
    maybeAddRole(role, member) {
        if( member.roles.indexOf(role) !== -1 ) {
            return;
        }
        member.roles.push(role);
        this.teamChanged.emit({
            action: 'roleAdded',
            data: {
                role: role, 
                member: member
            }
        });
    }
    removeRole(role, member) {
        let i = member.roles.length;
        while(i--) {
            if( role == member.roles[i] ) {
                member.roles.splice(i, 1);
                this.teamChanged.emit({
                    action: 'roleRemoved',
                    data: {
                        role: role, 
                        member: member
                    }
                });
                break;
            }
        }
    }
    roleChange(e, role, member) {
        if( e.checked ) {
            this.maybeAddRole(role, member);
        } else {
            this.removeRole(role, member);
        }
    }
    toggleMemberSelect(open) {
        if( open ) {
            setTimeout(() => {
                this.panelOpen = open;
            }, 250);
            return;
        }
        this.panelOpen = !this.panelOpen;
    }
    toggleRoleSelect(i) {
        this.roleIndexOpen = i == this.roleIndexOpen ? -1 : i;
    }
}


// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/src/swarm/src/app/fields/team.component.ts